import React from 'react';
import cn from 'classnames';
import { IconButton } from 'components';
import { Modal } from 'components/Modal/Modal.component';
import { ButtonV3 } from 'components/ComponentV2';
import styles from './InviteConfirmationModal.module.scss';

export interface InviteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  isSingleMember?: boolean;
}

export const InviteConfirmationModal: React.FC<InviteConfirmationModalProps> = (
  props: InviteConfirmationModalProps
) => {
  const { isOpen, isSingleMember = false, onClose } = props;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={styles.Confirmation}
    >
      <div className={cn(styles.ConfirmationModal)}>
        <div className={styles.ConfirmationModalHeader}>
          <p className={styles.title}>🙌</p>
          <IconButton
            size="small"
            iconName="close"
            className={styles.closeIcon}
            onClick={onClose}
          />
        </div>
        <div className={cn(styles.ConfirmationModalContent)}>
          <p>
            {isSingleMember
              ? 'The member will receive an email invitation to join to your community. Let them know to look for and accept this email!'
              : 'Members will receive an email invitation to join to your community. Let them know to look for and accept this email!'}
          </p>
          <p>
            They can also join directly from your Community page. If the invite
            isn’t accepted you can invite them again after 3 months.
          </p>
        </div>
        <div className={styles.ConfirmationModalAction} id="modal-actions">
          <ButtonV3 color="primary" size="large" isFullWidth onClick={onClose}>
            Got it
          </ButtonV3>
        </div>
      </div>
    </Modal>
  );
};
